import { CONTACT_NUMBER } from "./constants";
import "./index.scss";
import Hook from "./useFooter";

const Footer = (props) => {
  const { translate } = Hook.useFooter(props);

  return (
    <div className="footer">
      <span>{translate("footer-message")}</span>
      <a href={`tel:${CONTACT_NUMBER}`} target="_blank">
        {CONTACT_NUMBER}
      </a>
    </div>
  );
};

export default Footer;
